import React, { useState, useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { eventTracker, goToTop } from '_helpers';
import styled from 'styled-components';
import images from '_images';
import { _ } from '_locales';

import apis from '_apis';
import Loader from './Loader';
import events from '../Education/events';
import { cts_secure } from '../../app/cts';

const NewsContainer = styled.div`
  margin-bottom: 45px;
  min-height: 400px;
`;

const NewsListBox = styled.ul`
  padding: 0 20px;
  max-width: 700px;
  margin: 0 auto;
  box-sizing: border-box;
`;

const NewsItem = styled.button`
  all: initial;
  font-family: Roboto, sans-serif !important;
  display: inline-block; 
  -moz-appearance: none;
  -webkit-appearance: none;
  border: none;
  outline: none;
  width: 100%;
  list-style: none;
  box-shadow: none;
  cursor: pointer;
  position: relative;
  font-weight: normal !important;

  &:focus {
    outline: none;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #eaeaea;
  }
`;

const NewsBox = styled.div`
  padding: 0 1em;
  cursor: pointer;
  width: 100%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;

  ${NewsItem}:focus > & {
    box-shadow: 0 0 2px 2px #51a7e8;
    border-radius: 5px;
  }

  &:focus {
    outline: none;
  }
  cursor: pointer;
`;

const NewsTitle = styled.h1`
  font-size: 14pt !important;
   
  text-shadow: #000000 0px 0px 1px;
  font-weight: 500 !important;
`;

const NewsDate = styled.h2`
  font-weight: normal !important;
  color: #031C2B;
  font-size: 14px !important;
   
  padding: 12px 0px;
  font-weight: 500 !important;
`;

const ListArrow = styled.span`
  position: absolute;
  top: 50%;
  right: 10px;
  margin-top: -7px;
  width: 10px;
  height: 13px;
  background: transparent url(${images.icons.collArrow}) top left;
  background-size: 10px 27px;
`;

const NoNewsAlert = styled.h3`
  text-align: center;
`;

const News = ({
  plugin, config, zone
}) => {
  const { projectId } = plugin;
  const { zoneStr } = zone;
  const { selectedLang, districtId } = config;

  // Hooks
  const [noNews, setNoNews] = useState(false);
  const [newsList, setNewsList] = useState(null);
  const [loading, setLoading] = useState(false);

  const match = useRouteMatch();
  const history = useHistory();

  useEffect(() => {
    const value = { action: 'news', title: 'News' };
    eventTracker('Plugin Click', value);
    eventTracker(events.NEWS_LIST_LOAD);
  }, []);

  useEffect(() => {
    // Getting news
    const getNewsList = async () => {
      try {
        setLoading(true);
        const { data, status } = await cts_secure('get', apis.getNewsApi(projectId, districtId, zoneStr, selectedLang));

        if (
          status !== 200
          || !Object.keys(data.items).length
        ) throw new Error('Error in getting news list.');

        setNewsList(data);
        setNoNews(false);
        return Promise.resolve(data);
      } catch (e) {
        setNoNews(true);
        return Promise.reject(e.message);
      } finally {
        setLoading(false);
      }
    };

    getNewsList();
  }, [districtId, selectedLang, projectId, zoneStr]);

  return (
    <div>
      {
        loading ? (<Loader />) : (
          <NewsContainer>
            <NewsListBox>
              {
                newsList
                  && Object.values(newsList) ? (
                  Object.values(newsList.items).map((item) => (
                    <li style={{ listStyle: 'none' }}>
                      <NewsItem
                        key={item.id}
                        onClick={() => [
                          goToTop(),
                          history.push(`${match.path}${item.id}`, {
                            content: item.body,
                            type: item.type,
                            date: item.date,
                          })
                        ]}
                        tabIndex="0"
                        aria-label={`Check the news details of ${item.title}`}
                      >
                        <NewsBox tabIndex="-1">
                          <NewsTitle>
                            {item.title}
                          </NewsTitle>
                          <NewsDate>
                            {item.date}
                          </NewsDate>
                          <ListArrow />
                        </NewsBox>
                      </NewsItem>
                    </li>
                  ))) : null
              }
              {
                noNews && (<NoNewsAlert>{_('news.there_are_no_current_notifications')}</NoNewsAlert>)
              }
            </NewsListBox>
          </NewsContainer>
        )
      }
    </div>
  );
};

export default News;
